<div class="tabela-container">
  <div class="tabela-info">
    <span class="info-total">
      {{ totalItens }} {{ totalItens === 1 ? 'item' : 'itens' }}@if (termoPesquisado) { para "<b>{{ termoPesquisado }}</b>" }
    </span>
    <div class="info-direita">
      <span class="atalhos">
        <span class="atalho">
          <mat-icon>arrow_upward</mat-icon><mat-icon>arrow_downward</mat-icon> Navega e expande
        </span>
        <span class="atalho"><kbd>+</kbd><kbd>-</kbd> Quantidade</span>
        <span class="atalho"><kbd>Enter</kbd> Adiciona</span>
        <span class="atalho"><kbd>Esc</kbd> Recolhe</span>
      </span>
      <mat-checkbox class="expandir-ao-navegar" [checked]="expandirAoNavegar"
        (change)="alterarExpandirAoNavegar($event.checked)">Expandir ao navegar</mat-checkbox>
      <span class="separador"></span>
      <span class="no-pedido">No pedido: <b>{{ qtdItensNoPedido }} {{ qtdItensNoPedido === 1 ? 'Item' : 'Itens' }} - {{ totalDoPedido | currency:'BRL' }}</b></span>
    </div>
  </div>
  <div class="tabela-scroll" #scroll [style.max-height.px]="alturaMaxima">
    <table class="tabela-itens">
      <thead>
        <tr>
          <th class="col-codigo">Código</th>
          <th class="col-descricao">Descrição</th>
          <th class="col-marca">Marca</th>
          <th class="direita col-unit">Unit.</th>
          <th class="centro col-qtde">QTDE</th>
          <th class="direita col-total">Total</th>
          <th class="col-acao"></th>
        </tr>
      </thead>
      @for (item of listaItens | paginate: {itemsPerPage: pagesize, currentPage: page, totalItems: totalItens}; track item.idItem) {
        <tbody app-linha-tabela-item
          [itemPesquisa]="item"
          [selecionado]="selecionadoId === item.idItem"
          [expandido]="expandidoId === item.idItem"
          (selecionar)="selecionar(item)"
          (alternarExpansao)="alternarExpansao(item)">
        </tbody>
      }
    </table>
  </div>
</div>
